import { getEnvVariable } from '@shared/config/runtime-env';
import { SIP_DOMAIN, SIP_PROTOCOL } from '@shared/config/sip';
import { CallState } from '@entities/call-item';

// STUN = 'stun:stun.ekiga.net, stun:stun.l.google.com:19302', 'stun:media.test.itgold.io:3478'
// SIP_PORT = ws 7080, wss 7443, wss 8443
const STUN = getEnvVariable('REACT_APP_STUN') ?? 'stun:stun.test.itgold.io';
const TURN = getEnvVariable('REACT_APP_TURN') ?? 'turn:media.test.itgold.io:3478';
const sipPort = getEnvVariable('REACT_APP_SIP_PORT');
const SIP_PORT = sipPort ? `:${sipPort}` : '';

export const CONFERENCE_FACTORY_URI = `${SIP_PROTOCOL}:conference-factory@${SIP_DOMAIN}`;
export const DEFAULT_PARK_URI = `${SIP_PROTOCOL}:park@${SIP_DOMAIN}`;

export const ICE_SERVERS: RTCIceServer[] = [
	// STUN
	{ urls: STUN.split(',') },
	// TURN
	{
		urls: TURN.split(','),
		username: 'testuser',
		credential: 'TestTest1',
	},
];

export const QUALITY_THRESHOLDS = {
	loss: { good: 0.01, medium: 0.03 }, // ≤1 %  / ≤3 %
	jitter: { good: 30, medium: 60 }, // мс
	drop: { good: 0.02, medium: 0.05 }, // ≤2 %  / ≤5 %
	rtt: { good: 150, medium: 300 }, // мс
};
export const REGISTRAR_SERVER = `${SIP_PROTOCOL}:${SIP_DOMAIN}`;

export const STATE_TO_STATUS_MAP: Record<CallState, string> = {
	accepted: '',
	declined: 'Нет ответа',
	hold: 'На удержании',
	parked: 'Припаркован собеседником',
	remoteHold: 'На удержании у собеседника',
	active: '',
	calling: 'Соединение...',
	incoming: 'Соединение',
};

// URL SIP-сервера
export const WS_SERVER = `wss://${SIP_DOMAIN}${SIP_PORT}/ws`;
